import React, { useState } from 'react'
import { useGetCampaignsQuery } from 'graphql/generated/graphql'
import CampaignsView from './components/CampaignsView/CampaignsView'
import { CampaignListSkeleton } from 'components/CampaignLoading/CampaignListSkeleton'

import Toastify from 'components/Toastify/Toastify'

export default function Campaigns(): JSX.Element {
  const [searchString, setSearchString] = useState('')
  const { loading, error, data, refetch } = useGetCampaignsQuery()

  return (
    <>
    {loading ? (
      <CampaignListSkeleton />
    ) : error ? (
        <Toastify />
      ) : !data?.campaigns ? (
        <Toastify />
      ) : (
        <CampaignsView
          searchString={searchString}
          data={data}
          setSearchString={setSearchString}
          filterData={refetch}
        />
      )}
    </>
  )
}
